import PropTypes from 'prop-types';
import React from 'react';
import { List } from '@prisjakt/ui-filters';
import T from '@prisjakt/ui-translate';
import { bemGenerator } from '@prisjakt/ui-base';

import './index.scss';

const styles = bemGenerator('campaign-categories', ['no-items']);

const mapCategories = (categories, counters) =>
  categories
    .filter(item => counters[item.id])
    .map(item => {
      const category = {
        id: item.id,
        name: item.name,
        products: counters[item.id] || 0,
      };

      if (item.children) {
        category.children = mapCategories(item.children, counters);
      }

      return category;
    });

const findCategory = (items, selected) => {
  if (!selected.parents || selected.parents.length === 0) {
    return items.find(item => item.id === selected.value);
  }

  return selected.parents
    .map(p => p.id)
    .reverse()
    .concat(selected.value)
    .reduce((itemTree, curr) => {
      const match = itemTree.find(node => node.id === curr);

      if (match.id === selected.value) {
        return match;
      }

      return match.children;
    }, items);
};

const Categories = props => {
  const aggregation = props.aggregations || [];

  const counters = aggregation.reduce(
    (all, curr) =>
      Object.assign(all, {
        [curr.key]: curr.doc_count,
      }),
    {}
  );

  const categoryTree = props.categoryTree || [];
  const items = mapCategories(categoryTree, counters);

  return (
    <span>
      {items.length !== 0 && (
        <List
          id="category"
          values={items}
          selected={props.selected}
          onChange={selected => {
            props.onChange(selected, findCategory(items, selected));
          }}
          expanded={props.expanded}
          onExpand={props.onExpand}
          autoSelectChildren={false}
        />
      )}

      {items.length === 0 && (
        <p className={styles['no-items']}>
          <T domain="campaigns">category.no-items</T>
        </p>
      )}
    </span>
  );
};

const { func, object, arrayOf, string, number, array, shape } = PropTypes;

Categories.propTypes = {
  onChange: func.isRequired,
  currentState: object, // eslint-disable-line react/forbid-prop-types,
  aggregations: arrayOf(
    shape({
      key: string,
      doc_count: number,
    })
  ),
  selected: arrayOf(string).isRequired,
  expanded: arrayOf(string).isRequired,
  onExpand: func.isRequired,
  categoryTree: array, // eslint-disable-line react/forbid-prop-types,
  data: object, // eslint-disable-line react/forbid-prop-types,
};

Categories.defaultProps = {
  aggregations: [],
  categoryTree: undefined,
  data: undefined,
  currentState: { selected: [] },
};

export default Categories;
